import React from "react";

import { PEDIDO_INTEGRACAO_REPORT_MAX_DAYS } from "../../../utils/pedidoIntegracaoReportPeriod";

type RelatorioPeriodoMaxHintProps = {
  className?: string;
};

const RelatorioPeriodoMaxHint: React.FC<RelatorioPeriodoMaxHintProps> = ({
  className = "mt-3",
}) => (
  <p className={`text-xs text-neutral-500 ${className}`}>
    O período máximo por consulta é de{" "}
    <span className="font-medium text-neutral-700">
      {PEDIDO_INTEGRACAO_REPORT_MAX_DAYS} dias
    </span>
    . Intervalos maiores não são processados por limitação de desempenho.
  </p>
);

export default RelatorioPeriodoMaxHint;
